import { Typography, Stack, Button } from "@mui/material";
import HomeTemplate from "pages/HomeTemplate/HomeTemplate";
import { useHistory } from "react-router-dom";
import AddIcon from "@mui/icons-material/Add";
import CardMyCnpjs from "components/DataDisplay/CardMyCnpjs/CardMyCnpjs";
import { useConsigazApi } from "hooks/useConsigazApi";
import { useEffect, useState } from "react";
import DeleteLinkCnpjModal from "components/DataDisplay/DeleteLinkCnpjModal/DeleteLinkCnpjModal";
import ClienteService from "services/cliente";
import { useAuth } from "hooks/useAuth";
import CondominioService from "services/condominio";
import { toast } from "react-toastify";

export default function MyCNPJs() {
  const history = useHistory();
  const [myCnpjs, setMyCnpjs] = useState();
  const [pendingDelete, setPendingDelete] = useState(null);

  const api = useConsigazApi();
  const { userCpf } = useAuth();

  const getMyCnpjs = async () => {
    await api
      .consultMyCnpjs({ cpf: userCpf })
      .then(({ RetornoCNPJ }) => setMyCnpjs(RetornoCNPJ));
  };

  useEffect(() => {
    getMyCnpjs();
  }, []);

  const refresh = async () => {
    getMyCnpjs();
  };

  const hasCnpjs = myCnpjs && myCnpjs.length;

  const handleChangeCnpj = async (data) => {
    try {
      const { Cliente } = await api.consultaLocalEntrega(data.cnpj);

      if (!Cliente) {
        return toast.error("Cliente não encontrado.");
      }

      ClienteService.localEntrega = Cliente.ClienteRetorno[0];
      CondominioService.selected =
        Cliente.ClienteRetorno[0].ClienteEntrRetorno[0];

      return history.push("/home");
    } catch (error) {
      return toast.error(error);
    }
  };

  const router = useHistory();

  const { CPFCNPJ } = ClienteService.localEntrega;

  return (
    <HomeTemplate history={history}>
      <Stack p={"0 150px"}>
        <Stack
          direction={"row"}
          justifyContent={"space-between"}
          alignItems={"center"}
          mb={"26px"}
        >
          <Typography fontSize={"18px"} fontWeight={700} color="#636363">
            Alterne seu acesso ou adicione um novo vínculo de CNPJ
          </Typography>
          <Button
            variant="contained"
            startIcon={<AddIcon />}
            sx={{
              bgcolor: "#2CABF9",
            }}
            onClick={() => router.push("/link-cnpj")}
          >
            Novo CNPJ
          </Button>
        </Stack>
        {hasCnpjs &&
          myCnpjs.map((i) => {
            const isActive = i.Cnpj === CPFCNPJ;

            return (
              <CardMyCnpjs
                key={i.Cnpj}
                cnpj={i.Cnpj}
                name={i.Nome}
                isActive={isActive}
                onRequestDelete={(i) => setPendingDelete(i)}
                onChangeCnpj={(i) => handleChangeCnpj(i)}
              />
            );
          })}
        <DeleteLinkCnpjModal
          open={!!pendingDelete}
          onClose={() => setPendingDelete(null)}
          name={pendingDelete?.name ?? ""}
          cnpj={pendingDelete?.cnpj ?? ""}
          refresh={refresh}
        />
      </Stack>
    </HomeTemplate>
  );
}
